
import React from 'react';
import axios from 'axios';
import $ from 'jquery';
import { getSessionID, getSessionName, getCompanyID, getUserID } from '../../../../Utils/Common';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory from 'react-bootstrap-table2-filter';

class EmployeeUserAdjustments extends React.Component {
  constructor () {
      super();

      this.state = {
        tableData:[]
      };
  }

  componentDidMount () {
    let self = this;

    const session_Name = getSessionName();
    if (!session_Name) {
      return;
    }
  
    const session_ID = getSessionID();
    if (!session_ID) {
      return;
    }
  
    const company_id = getCompanyID();
    if (!company_id) {
      return;
    }

    const user_id = getUserID();
    if (!user_id) {
      return;
    }

    
    axios.get('http://payroll.nikkolim.com/get_adjustments/employee_adjustments/'+user_id, {
    headers: {
      'Content-Type': 'application/json',
      "Authentication": session_Name+"="+session_ID,
    }
  })
  .then((response) => {
    const data = [];
    $.each( response.data, function( i, val ) {   
        //console.log(JSON.stringify(val));
      $.each(val, function( i, val2 ){
        data.push(val2.attributes);
        self.setState({
            tableData: data
        });
        //console.log(JSON.stringify(data));
      })
      
    });
    //console.log(JSON.stringify(response.data));
  }, (error) => {
    console.log(error);
  });
  
  }

//   valueFormatter(cell, row){
//     return (
//       <div><a className="btn btn-primary" href={"employees-details/"+cell}>View Details</a></div>
//       );
//   }

  render () {
      const { tableData } = this.state;
      const textfilter = { type: 'TextFilter', delay: 1000};
      const datefilter = { type: 'DateFilter', delay: 1000};

      let datalist = [{
        dataField: 'field_adjustment_employee_label',
        text: 'Employee',
      }, {
        dataField: 'field_adjustment_name',
        text: 'Word Adjustment Type'
      }, {
        dataField: 'field_adjustment_entry_date',
        text: 'Entry Date'
      }, {
        dataField: 'field_adjustment_amount',
        text: 'Amout'
      },{
        dataField: 'field_adjustment_payment_date',
        text: 'Payment Date'
      },{
        ataField: 'field_adjustment_notes',
        text: 'Notes'
      },{
        dataField: 'entity_id',
        text: 'ID'
      }];
      
      return (
        
      <div>
        <h1 class="h3 mb-0 text-gray-800">Adjustments</h1>
        <BootstrapTable responsive wrapperClasses='table-responsive' bootstrap4 version='4' keyField='entity_id' filter={ filterFactory() } columns={ datalist } data={ tableData } pagination={ paginationFactory() } search>
          <TableHeaderColumn dataSort dataField='field_adjustment_employee_label' >Employee</TableHeaderColumn>
          <TableHeaderColumn dataSort  dataField='field_adjustment_name' filter={textfilter}>Word Adjustment Type</TableHeaderColumn>
          <TableHeaderColumn dataSort  dataField='field_adjustment_entry_date' filter={datefilter}>Entry Date</TableHeaderColumn>
          <TableHeaderColumn dataField='field_adjustment_amount'>Amout</TableHeaderColumn>
          <TableHeaderColumn dataField='field_adjustment_payment_date' filter={datefilter}>Payment Date</TableHeaderColumn>
          <TableHeaderColumn dataField='field_adjustment_notes' filter={textfilter}>Notes</TableHeaderColumn>
        </BootstrapTable>
      </div>  
      );
  }
};



export default EmployeeUserAdjustments;

